import React, { useEffect, useMemo, useState } from "react";
import Carousel from "nuka-carousel";
import { useDispatch, useSelector } from "react-redux";
import { fetchTopLearners } from "../../Redux/LearnersReport";
import { BASE_API_URL } from "../../utils/constants";
import "./IgniteLearnersSection.css";

const badgeMap = {
  diamond: `${process.env.PUBLIC_URL}/Assets/Home/learners/Diamond-Medal.png`,
  platinum: `${process.env.PUBLIC_URL}/Assets/Home/learners/Platinum-Medal.png`,
  gold: `${process.env.PUBLIC_URL}/Assets/Home/learners/Gold-Medal.png`,
  silver: `${process.env.PUBLIC_URL}/Assets/Home/learners/Silver-Medal.png`,
  bronze: `${process.env.PUBLIC_URL}/Assets/Home/learners/Bronze-Medal.png`,
};

const getInitials = (name) => {
  if (!name) return "NA";
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

const CarouselComponent = () => {
  const dispatch = useDispatch();

  const { topLearners, loader, error, topLearnersLoaded } = useSelector(
    (state) => state.learnersReport,
  );

  const isEmpty =
    topLearnersLoaded && (!topLearners || topLearners.length === 0);

  const userData = useSelector((state) => state.userDetails.userData?.[0]);

  const [slidesToShow, setSlidesToShow] = useState(3);
  const [slidesToScroll, setSlidesToScroll] = useState(3);
  const businessUnit = useMemo(
    () => userData?.businessUnit,
    [userData?.businessUnit],
  );

  useEffect(() => {
    if (!businessUnit) {
      return;
    }
    dispatch(fetchTopLearners(businessUnit));
  }, [dispatch, businessUnit]);

  // Responsive slides
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 767) {
        setSlidesToShow(1);
        setSlidesToScroll(1);
      } else if (window.innerWidth <= 1023) {
        setSlidesToShow(2);
        setSlidesToScroll(2);
      } else {
        setSlidesToShow(3);
        setSlidesToScroll(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Convert API data to UI data
  const learnersData = (topLearners || []).slice(0, 9).map((item, index) => {
    const profileImage = item.photo ? `${BASE_API_URL}/${item.photo}` : null;

    const normalizedBadge = item.highestBadge?.trim().toLowerCase();
    const badgeImage = badgeMap[normalizedBadge] || null;

    return {
      id: index + 1,
      name: item.name || item.enterpriseId,
      title: item.role || "Top Learner",
      quote: `Total Points : ${item.totalPoints}`,
      profileImage,
      initials: getInitials(item.name),
      badge: badgeImage,
    };
  });

  console.log("learners length", learnersData?.length);

  return (
    <div className="learner-carousel-wrapper">
      {learnersData?.length === 0 ? (
        <div
          style={{
            width: "100%",
            textAlign: "center",
            padding: "24px",
            fontSize: "1rem",
          }}
        >
          No learners' data recorded yet
        </div>
      ) : (
        <Carousel
          slidesToShow={slidesToShow}
          slidesToScroll={slidesToScroll}
          renderCenterLeftControls={({ previousSlide }) => (
            <button onClick={previousSlide} className="nav-btn">
              &lsaquo;
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button onClick={nextSlide} className="nav-btn">
              &rsaquo;
            </button>
          )}
        >
          {learnersData.map((item) => (
            <div className="card" key={item.id}>
              <div className="profile">
                <div className="profile-img-box">
                  {item.profileImage ? (
                    <img
                      src={item.profileImage}
                      alt={item.name}
                      className="ignite-learner-img"
                    />
                  ) : (
                    <div className="ignite-learner-img initials-box">
                      {item.initials}
                    </div>
                  )}

                  {item.badge && (
                    <img
                      src={item.badge}
                      alt="badge"
                      className="ignite-learner-label"
                    />
                  )}
                </div>

                <div className="profile-content-box">
                  <h4>{item.name}</h4>
                  <span>{item.title}</span>
                  <p className="quote-text">{item.quote}</p>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default CarouselComponent;
